import Dashboard from '@/views/private/dashboard'
import MyAccount from '@/views/private/my-account'
import MyCurriculum from '@/views/private/my-curriculum'
import Curriculum from '@/views/private/curriculum'
import Tickets from '@/views/private/tickets/list'
import TicketDetails from '@/views/private/tickets/details'
import Jobs from '@/views/private/jobs'
import Administration from '@/views/private/administration'
import Users from '@/views/private/user'
import teste from '@/views/private/teste'
import Message from '@/views/private/message'


import Configurations from '@/views/private/configurations'
import ConfigMenu from '@/views/private/configurations/menu'
import Roles from '@/views/private/configurations/roles'
import Others from '@/views/private/configurations/others'
import Departaments from '@/views/private/configurations/departaments'
import Permissions from '@/views/private/configurations/permissions'

var routes =  [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            private: true,
        }
    },
    {
        path: '/configuracoes',
        name: 'configurations',
        component: Configurations,
        meta: {
            private: true,
            permission: ['config_manager']
        },
        redirect: { name: 'config-menu' },
        children: [
            {
                path: '',
                name: 'config-menu',
                component: ConfigMenu,
                meta: {
                    private: true,
                    permission: ['config_manager']
                },
            },
            {
                path: 'tipos-de-usuarios',
                name: 'config-roles',
                component: Roles,
                meta: {
                    private: true,
                    permission: ['config_user_types']
                },
            },
            {
                path: 'outros',
                name: 'config-others',
                component: Others,
                meta: {
                    private: true,
                    permission: ['config_others']
                },
            },
            {
                path: 'permissoes/:role',
                name: 'permissions',
                component: Permissions,
                meta: {
                    private: true,
                    permission: ['config_permissions_user']
                },
            },
            {
                path: 'departamentos',
                name: 'config-departaments',
                component: Departaments,
                meta: {
                    private: true,
                    permission: ['config_manager']
                },
            },
        ]
    },
    {
        path: '/administracao',
        name: 'administration',
        component: Administration,
        meta: {
            private: true
        }
    },
    {
        path: '/teste',
        name: 'teste',
        component: teste,
        meta: {
            private: true
        }
    },
    {
        path: '/acesso-negado',
        name: 'access-block',
        component: Message,
        meta: {
            private: true
        }
    },
    {
        path: '/minha-conta',
        name: 'my-account',
        component: MyAccount,
        meta: {
            private: true
        }
    },
    {
        path: '/meu-curriculo',
        name: 'my-curriculum',
        component: MyCurriculum,
        meta: {
            private: true,
            permission: ['edit_my_curriculum']
        }
    },
    {
        path: '/curriculo/:userid',
        name: 'curriculum',
        component: Curriculum,
        meta: {
            private: true,
            permission: ['edit_my_curriculum']
        }
    },
    {
        path: '/ouvidoria',
        name: 'ouvidoria',
        component: Tickets,
        meta: {
            private: true,
            permission: ['tickets_list','tickets_list_my','tickets_list_my_responsibility']
        }
    },
    {
        path: '/ouvidoria/:id',
        name: 'ouvidoria-details',
        component: TicketDetails,
        meta: {
            private: true,
            permission: ['ticket_view']
        }
    },
    {
        path: '/usuarios/:role',
        name: 'users',
        component: Users,
        meta: {
            private: true,
            permission: ['users_list']
        }
    },
    {
        path: '/vagas-de-emprego',
        name: 'jobs',
        component: Jobs,
        meta: {
            private: true,
            permission: ['jobs_list']
        }
    },
]

export { routes }